import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { FileDown, Printer } from "lucide-react";
import { REKAP_COLS, formatH, curMonth } from "@/lib/sihtarica";
import { exportCSV } from "@/lib/format";

export default function Rekapitulacija() {
  const [month, setMonth] = useState(curMonth());
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/evidencija/rekapitulacija", { params: { month } }).then((r) => setData(r.data)).catch(() => {});
  }, [month]);

  const cell = (row, c) => (c.int ? row[c.key === "topli" ? "topli" : c.key] : formatH(row[c.key]));

  const handleExport = () => {
    const headers = ["RB", "Ime i prezime", ...REKAP_COLS.map((c) => c.label)];
    const rows = (data?.rows || []).map((r, i) => [i + 1, r.worker_name, ...REKAP_COLS.map((c) => cell(r, c))]);
    if (data?.totals) rows.push(["", "UKUPNO", ...REKAP_COLS.map((c) => (c.int ? data.totals.topli : formatH(data.totals[c.key])))]);
    exportCSV(`rekapitulacija_${month}`, headers, rows);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 className="text-2xl sm:text-3xl font-extrabold font-heading tracking-tight">Rekapitulacija rada</h1>
          <p className="text-sm text-muted-foreground mt-1">{data?.firma || "PELESIĆ d.o.o. Tuzla"} · pregled radnih sati za obračun plata</p>
        </div>
        <div className="flex flex-wrap items-center gap-2 no-print">
          <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="w-full sm:w-48" data-testid="rekap-month-input" />
          <Button variant="outline" size="sm" onClick={handleExport} data-testid="rekap-export-excel"><FileDown className="h-4 w-4 mr-1.5" /> Excel</Button>
          <Button variant="outline" size="sm" onClick={() => window.print()} data-testid="rekap-export-pdf"><Printer className="h-4 w-4 mr-1.5" /> Print</Button>
        </div>
      </div>

      <div className="rounded-xl border bg-card shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-secondary/60 hover:bg-secondary/60">
                <TableHead className="w-[40px]">RB</TableHead>
                <TableHead className="min-w-[160px]">Ime i prezime</TableHead>
                {REKAP_COLS.map((c) => <TableHead key={c.key} className="text-right whitespace-nowrap">{c.label}</TableHead>)}
              </TableRow>
            </TableHeader>
            <TableBody>
              {!data ? (
                <TableRow><TableCell colSpan={REKAP_COLS.length + 2} className="h-24 text-center text-muted-foreground">Učitavanje...</TableCell></TableRow>
              ) : data.rows.length === 0 ? (
                <TableRow><TableCell colSpan={REKAP_COLS.length + 2} className="h-24 text-center text-muted-foreground">Nema aktivnih radnika.</TableCell></TableRow>
              ) : (
                <>
                  {data.rows.map((r, i) => (
                    <TableRow key={r.worker_id} data-testid="rekap-row">
                      <TableCell className="tabular-nums">{i + 1}</TableCell>
                      <TableCell className="font-medium whitespace-nowrap">{r.worker_name}</TableCell>
                      {REKAP_COLS.map((c) => <TableCell key={c.key} className="text-right tabular-nums">{cell(r, c)}</TableCell>)}
                    </TableRow>
                  ))}
                  <TableRow className="bg-secondary/60 font-bold">
                    <TableCell />
                    <TableCell>UKUPNO</TableCell>
                    {REKAP_COLS.map((c) => <TableCell key={c.key} className="text-right tabular-nums">{c.int ? data.totals.topli : formatH(data.totals[c.key])}</TableCell>)}
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
